// extracted by mini-css-extract-plugin
export default {"gallery":"XhKQw","galleryItem":"Qg53j","productItem":"jMx1r","wrapper":"qbKP9","productItemUzb":"hthKe"};